import { getBrowserRuntime, hasBrowserDocument } from '../browser-runtime';

export function getCookie(name: string) {
  if (!hasBrowserDocument()) {
    return false;
  }

  const exp = new RegExp('[; ]' + name + '=([^\\s;]*)');
  const cookie = getBrowserRuntime().document?.cookie;
  const matches = (' ' + cookie)?.match(exp);

  return matches?.[1] || false;
}
